export default __webpack_public_path__ + "static/media/search.a6d4d17d.png";